import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');
const cloneDeep = require('lodash/cloneDeep');
const forEach = require('lodash/forEach');
const find = require('lodash/find');

const ServerRequest = require('../../actions/request');
const Globals = require('../../../../app/globals');
import Authinator from '../Authinator';

const CLIENT_ID = Globals.GAPI_CLIENT_ID;
const SCOPES = [
    "https://www.googleapis.com/auth/classroom.rosters.readonly",
    "https://www.googleapis.com/auth/classroom.profile.emails",
    "https://www.googleapis.com/auth/classroom.courses",
    "https://www.googleapis.com/auth/classroom.coursework.students"
];

const propTypes = {
    activityID: PropTypes.string.isRequired,
    activityVersion: PropTypes.string.isRequired,
    onViewAssigment: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    activityName: PropTypes.string,
    hasCredentials: PropTypes.bool,
    missingCredentialsText: PropTypes.string,
};

const defaultProps = {
    activityName: 'Assignment',
    hasCredentials: false,
    missingCredentialsText: '',
};

class GoogleClassroomCreateUI extends React.Component {
    constructor(props) {
        super(props);

        let errorText = '';
        if (!props.hasCredentials) {
            errorText = props.missingCredentialsText;
        }

        this.state = {
            showCreateDialog: true,
            authenticated: false,
            userProfile: null,
            gotCourses: false,
            courses: [],
            courseId: '',
            title: props.activityName,
            description: '',
            creatingAssignment: false,
            errorText: errorText,
            errorCode: '',
            resultText: '',
            resultRoute: '',
            retryCount: 0,
        };

        this.requestUserProfile = this.requestUserProfile.bind(this);
        this.requestCourses = this.requestCourses.bind(this);
        this.closeCreateDialog = this.closeCreateDialog.bind(this);
        this.createAssignmentHandler = this.createAssignmentHandler.bind(this);
        this.getStudentProfiles = this.getStudentProfiles.bind(this);
        this.createAssignmentHandlerPart2 = this.createAssignmentHandlerPart2.bind(this);
        this.onSelectCourse = this.onSelectCourse.bind(this);
        this.onTitleChange = this.onTitleChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.onAuthComplete = this.onAuthComplete.bind(this);
        this.handleRejectAuthorization = this.handleRejectAuthorization.bind(this);
        this.renderAuthDialog = this.renderAuthDialog.bind(this);
        this.renderErrorDialog = this.renderErrorDialog.bind(this);
        this.renderWaitDialog = this.renderWaitDialog.bind(this);
        this.onViewCreatedAssignment = this.onViewCreatedAssignment.bind(this);
        this.renderResultDialog = this.renderResultDialog.bind(this);
        this.renderModalCreateDialog = this.renderModalCreateDialog.bind(this);
    }

    componentWillUnmount() {
        if (this.stopMe) {
            clearTimeout(this.stopMe);
        }
    }

    requestUserProfile() {
        var self = this;
        var request = gapi.client.classroom.userProfiles.get({userId : 'me'});
        this.stopMe = 0;
        request.execute(function (resp) {
            if (resp.error) {
                // console.log(resp.error);
                var autoRetry = (self.state.retryCount < 2);
                var suffix = autoRetry ? " Retrying..." : "";
                self.setState({
                    errorText: (resp.error.message || 'Unknown error') + suffix,
                    retryCount: self.state.retryCount + 1,
                    authorized: !autoRetry,
                    resultText: autoRetry ? 'requesting user profile...' : ''
                });
                if (autoRetry) {
                    self.stopMe = window.setTimeout(self.requestUserProfile,1000);
                }
                return;
            }

            self.setState({
                resultText: '',
                userProfile: resp.result,
            }, () => {
                self.requestCourses();
            });
        });
    }

    requestCourses() {
        const self = this;
        var request = gapi.client.classroom.courses.list({ pageSize : 10 });
        request.execute((resp) => {
            self.setState({
                gotCourses: true,
                courses: cloneDeep(resp.courses)
            });
        });
    }

    closeCreateDialog() {
        var stayAuthorized = this.state.authorized;
        if (!this.state.userProfile) {
            stayAuthorized = false;
        }

        this.setState({
            showCreateDialog: false,
            authenticated: stayAuthorized,
        }, () => {
            this.props.onClose();
        });
    }

    createAssignmentHandler() {
        this.setState({ studentProfiles: [] }, () => {
            this.getStudentProfiles();
        });
    }

    getStudentProfiles(pageToken) {
        const self = this;
        return gapi.client.classroom.courses.students.list({
            courseId: self.state.courseId,
            pageSize: 0,
            pageToken: pageToken
        })
        .then(
            function (resp) {
                var studentProfiles = self.state.studentProfiles.slice();
                forEach(resp.result.students, function(student) {
                    studentProfiles.push(student.profile);
                });
                self.setState({studentProfiles:studentProfiles});
                if (resp.result.nextPageToken) {
                    self.getStudentProfiles(resp.result.nextPageToken);
                }
                else {
                    self.createAssignmentHandlerPart2();
                }
            },
            function(reason) {
                if (GlobalConfig.DebugMode) {
                    console.log("error getting students.");
                    console.log(reason);
                }

                self.setState({
                    creatingAssignment: false,
                    errorText: reason.error.message,
                    errorCode: reason.error.code
                });
            }
        );
    }

    // called after we have our student profiles
    createAssignmentHandlerPart2() {
        var self = this;
        if (!this.state.courseId) {
            alert("Select a course first.");
            return;
        }

        this.setState({
            creatingAssignment: true
        });

        var assignmentHash = 'A-' + String(uuid.v4()); // In Soviet Russia, assignment creates you!
        var googleClassroomRoute = '/assignment/' + assignmentHash + '/gc';
        var googleClassroomUrl = GlobalConfig.ApiUrl + googleClassroomRoute;

        // var fields = []; // option if we don't want all the data
        var courseWork = {
            title : self.state.title,
            description : self.state.description,
            materials : [{
                link : {
                    url : googleClassroomUrl
                    // These don't currently seem to function
                    // title: 'Launch',
                    // thumbnailUrl: 'https://s3.amazonaws.com/mzlcontent/forge/4.7.2/img/logo-grey-1.svg',
                }
            }],
            maxPoints: 100,
            workType : 'ASSIGNMENT',
            // state : 'PUBLISHED', // defaults to DRAFT, which shows up under saved posts in classroom
        };

       // console.log("sending courseWork: " + JSON.stringify(courseWork));
        var request = gapi.client.classroom.courses.courseWork.create({
            courseId: self.state.courseId
        }, courseWork);
        request.execute(function (resp) {
            if (resp.error) {
                if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                    console.log(resp.error);
                }

                if (resp.error.message) {
                    self.setState({
                        creatingAssignment: false,
                        errorText: resp.error.message,
                        errorCode: resp.error.code
                    });
                }
                else {
                    console.log("Error response from gapi:",resp);
                    self.setState({
                        creatingAssignment: false,
                        errorText: "Generic error",
                        errorCode: ''
                    });
                }
            }
            else {
                // console.log("courseWork.create result:" + JSON.stringify(resp.result));

                // Create the assignment in forge
                var courseWorkId = resp.result.id;
                var params = {
                    assignmentHash: assignmentHash,
                    courseId: self.state.courseId,
                    userProfile: self.state.userProfile,
                    courseWorkId: courseWorkId,
                    title: self.state.title,
                    studentProfiles: self.state.studentProfiles
                };
                // console.log("create_gc_assignment params:" + JSON.stringify(params));
                ServerRequest.makeRequest('/authoring/create_gc_assignment/' +  self.props.activityID + '/' + self.props.activityVersion, 'POST',JSON.stringify(params) )
                .then(function(result) {
                    self.setState({
                        creatingAssignment: false,
                        resultText: "Assignment Created",
                        resultRoute: googleClassroomRoute,
                        errorText: '',
                        errorCode: ''
                    });
                })
                .catch(function(err) {
                    if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                        console.log(err);
                    }
                    self.setState({
                        creatingAssignment: false,
                        errorText: "Failed to complete assignment setup.",
                        errorCode: ''
                    });

                });
            } // else success
        }); // execute
    }

    onSelectCourse(e) {
        this.setState({courseId: e.target.value})
    }

    onTitleChange(e) {
        this.setState({title: e.target.value});
    }

    onDescriptionChange(e) {
        this.setState({description: e.target.value});
    }

    onAuthComplete() {
        this.setState({
            authenticated: true,
            resultText: "Requesting user profile...",
        }, () => {
            this.requestUserProfile();
        });
    }

    handleRejectAuthorization() {
        this.props.onClose();
    }

    renderAuthDialog() {
        return (
          <Authinator scope={SCOPES} onSuccess={this.onAuthComplete} onReject={this.handleRejectAuthorization}/>
        );
    }

    renderErrorDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                //container={mountNode}
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>Create Assignment in Google Classroom</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.errorCode && ('Error ' + this.state.errorCode + ': ')}
                    {this.state.errorText}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant='primary' onClick={this.closeCreateDialog}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    renderWaitDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                //container={mountNode}
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>Create Assignment in Google Classroom</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {'Creating Assignment...'}
                </Modal.Body>
            </Modal>
        );
    }

    onViewCreatedAssignment() {
        this.props.onViewAssigment(this.state.resultRoute);
    }

    renderResultDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                //container={mountNode}
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>Create Assignment in Google Classroom</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.resultText}
                    <div className="seperator-thick"/>
                    {this.state.resultRoute && <Button variant='primary' onClick={this.onViewCreatedAssignment}>View</Button>}
                </Modal.Body>
            </Modal>
        );
    }

    renderModalCreateDialog() {
        var self = this;

        if (this.props.hasCredentials && !this.state.authenticated) {
            return this.renderAuthDialog();
        }

        if (this.state.errorText) {
            return this.renderErrorDialog();
        }

        if (this.state.creatingAssignment) {
            return this.renderWaitDialog();
        }

        if (this.state.resultText) {
            return this.renderResultDialog();
        }

        var courseOptions = [];
        var selectedCourse = find(this.state.courses,{id: this.state.courseId});
        if (!selectedCourse) {
            courseOptions.push(<option key={'hidden_nothing'} disabled hidden style={{display: 'none'}} value=''></option>);
        }
        forEach(this.state.courses,function(course,index) {
            var disabled = false;
            var extra = '';
            if (course.courseState !== 'ACTIVE') {
                disabled = true;
                extra = ' (' + course.courseState + ')';
            }
            courseOptions.push(<option key={course.id} value={course.id} disabled={course.courseState !== 'ACTIVE'}>{course.name + extra}</option>);
        });

        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus={true}
                backdrop={false}
                animation={false}
                keyboard={true}
                //container={mountNode}
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>Create Assignment in Google Classroom</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group>
                        <label className="label-form" htmlFor="gccui-course-select">Course</label>
                        <br/>
                        <select id="gccui-course-select" value={this.state.courseId} onChange={this.onSelectCourse}>
                            {courseOptions}
                        </select>
                        <br/>

                        <Form.Label htmlFor="courseWorkTitle">Assignment Title</Form.Label>
                        <Form.Control id="courseWorkTitle" type='text' value={this.state.title} onChange={this.onTitleChange}/>

                        <Form.Label htmlFor="courseWorkDescription">Assignment Description</Form.Label>
                        <Form.Control id="courseWorkDescription" type='text' value={this.state.description} onChange={this.onDescriptionChange}/>
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button disabled={!this.state.courseId} onClick={this.createAssignmentHandler}>Create</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        return this.renderModalCreateDialog();
    }
}

GoogleClassroomCreateUI.propTypes = propTypes;
GoogleClassroomCreateUI.defaultProps = defaultProps;

export default GoogleClassroomCreateUI;
